import { createReducer } from '../utils';

function removeItem(array, index) {
	return [...array.slice(0, index), ...array.slice(index + 1)];
}

const HIDE_TOAST_TIMEOUT = 3000;

const SHOW_TOAST = '@toast/ADD_TOAST';
const HIDE_TOAST = '@toast/HIDE_TOAST';

let nextToastId = 0;
export function doShowToast(type, text) {
	return (dispatch, getState) => {
		// Generate unique id
		const id = nextToastId++;

		setTimeout(() => {
			dispatch({ type: HIDE_TOAST, id });
		}, HIDE_TOAST_TIMEOUT);

		dispatch({
			type: SHOW_TOAST,
			id,
			props: {
				type,
				text,
				onClose: () => dispatch({ type: HIDE_TOAST, id })
			}
		});
	};
}

export function doHideToast(id) {
	return {
		type: HIDE_TOAST,
		id
	};
}

const initialState = [];

const toast = createReducer(initialState, {
	[SHOW_TOAST]: (state, { id, props }) => {
		return [...state, { id, props }];
	},
	[HIDE_TOAST]: (state, { id }) => {
		const index = state.findIndex(toast => toast.id === id);
		return removeItem(state, index);
	}
});

export function getToast(state) {
	return state.app.toast;
}

export default toast;



// WEBPACK FOOTER //
// ./src/js/reducers/app/toast.js